import React, { useCallback } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@rtkwlf/fenrir-react';
import { faPencil } from '@rtkwlf/pro-solid-svg-icons/faPencil';
import type { ScheduleRow } from '@rtkwlf/rendall';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { handleEditSchedule } from '../../../../../../../../../scan-schedules/scan-schedules.utils';

export const EditScheduleButton: React.FC<{
  scanScheduleRow: ScheduleRow;
}> = ({ scanScheduleRow }) => {
  const { t } = useTranslation('telemetryScannerConfig');
  const navigate = useNavigate();
  const { search } = useLocation();

  const { source, id, scannerId } = scanScheduleRow;

  const handleEdit = useCallback(() => {
    handleEditSchedule(id, navigate, source, scannerId, search);
  }, [id, navigate, scannerId, search, source]);

  return (
    <Button
      iconLeft={<FontAwesomeIcon icon={faPencil} />}
      variant="tertiary"
      onClick={handleEdit}
    >
      {t('actions.edit')}
    </Button>
  );
};
